import { render, staticRenderFns } from "./statsbar.vue?vue&type=template&id=a127228e&scoped=true&"
import script from "./statsbar.vue?vue&type=script&lang=js&"
export * from "./statsbar.vue?vue&type=script&lang=js&"
import style0 from "./statsbar.vue?vue&type=style&index=0&id=a127228e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a127228e",
  null
  
)

export default component.exports